import { render, staticRenderFns } from "./MedicoesEditar.vue?vue&type=template&id=f10d0fc0&scoped=true&"
import script from "./MedicoesEditar.vue?vue&type=script&lang=js&"
export * from "./MedicoesEditar.vue?vue&type=script&lang=js&"
import style0 from "./MedicoesEditar.vue?vue&type=style&index=0&id=f10d0fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10d0fc0",
  null
  
)

export default component.exports